<div class="profile-details" [ngClass]="{ 'is-Acmic': isAcmic, 'is-not-Acmic': !isAcmic}">
  <div class="row text-center no-margin-horizontal">
    <div class="col no-padding">
      <h1 id="profilePwdTitle" class="title-copy no-margin profile-password-heading" [ngClass]="{  'fw-normal': !isAcmic}" >{{ 'PROFILE_PASSWORD_TITLE' | translate }}</h1> 
      <div  [ngClass]="{  'brand-lite-blue profile-password-subHeading-ma': !isAcmic, 'profile-password-subHeading': isAcmic}">
        {{ whereInTheProcessTitle() | translate }} 
      </div>
    </div>
  </div>
  
  <div *ngIf="whereInTheProcess === 'enter-password';else editPassword">
    <app-change-password-form [inputs]="changePassword" [userData]="user"></app-change-password-form>
  </div>
  <ng-template #editPassword>
    <app-create-password-form [inputs]="changePassword" [userData]="user"></app-create-password-form>
  </ng-template>
</div>
